
           <div class="mb-3">
             <div class="clearfix">
   
            
               <div class="" style="text-align: center">
               <div class="" >
               <div class=" align-middle">
               <p class="mb-1 fnt-weight500 center">{{mls.languageText.event_going_modal.key1}}<span *ngIf="mls?.is_lskey_display==1">(event_going_modal.key1)</span></p>
               
               <p class="fnt-weight500 text-medium-grey mb-2 fnt-size12px">{{mls.languageText.event_going_modal.key2}}<span *ngIf="mls?.is_lskey_display==1">(event_going_modal.key2)</span></p>

               
               </div>
               </div>
               </div>
               </div>

               

         </div>
             <div class="row">
                 <!-- <div class="col-6 pr-1">
                     <span class="btn bg-white fnt-size14px w-100 border cursor-pointer text-very-dark" (click)="cancelSubscribemodal()">Close</span></div> -->
                 <div class="col-12 pl-1"><span class="btn btn-success fnt-size14px w-100 cursor-pointer"  (click)="productshare()">
                     <span *ngIf="api_in_process==true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                     {{mls.languageText.event_going_modal.key3}}<span *ngIf="mls?.is_lskey_display==1">(event_going_modal.key3)</span></span></div>
             </div>         
  